import React, { useCallback } from "react";
import { Box, Button, Flex, Icon } from "orcs-design-system";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";

const ImageDropZone = ({
  onFileImported,
  btnLabel,
  disabled,
  onRemove,
  showRemove = false,
}) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        // Check if file size over 200kb
        if (file.size > 204800) {
          throw new Error(`File size too big ${file.size}`);
        }
        const reader = new FileReader();

        reader.onload = () => {
          const str = reader.result;
          onFileImported(str);
        };

        reader.readAsDataURL(file);
      });
    },
    [onFileImported]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <Flex gap="s" alignItems="center" mt="r">
      <Box {...getRootProps()}>
        <input {...getInputProps()} disabled={disabled} />
        <Button disabled={disabled}>
          <Icon icon={["fas", "cloud-upload"]} mr="s" />
          {btnLabel}
        </Button>
      </Box>
      {showRemove && (
        <Button
          type="button"
          variant="ghost"
          onClick={onRemove}
          disabled={disabled}
        >
          <Icon icon={["fas", "times"]} mr="s" />
          Remove
        </Button>
      )}
    </Flex>
  );
};

ImageDropZone.propTypes = {
  onFileImported: PropTypes.func,
  btnLabel: PropTypes.string,
  disabled: PropTypes.bool,
  onRemove: PropTypes.func,
  showRemove: PropTypes.bool,
};

export default ImageDropZone;
